<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      title="查看调研问卷明细异常信息信息"
      :visible.sync="dialogVisible"
      class="abow_dialog h660_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogViewForm"
        :model="dialogViewForm"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            调研问卷明细异常信息信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="活动省区">
                  <el-input
                    v-model="dialogViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="活动日期">
                  <el-date-picker
                    v-model="dialogViewForm.activityDate"
                    type="date"
                    format="yyyy-MM-dd"
                    disabled
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷编号">
                  <el-input
                    v-model="dialogViewForm.questionnaireCode"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="问卷名称">
                  <el-input
                    v-model="dialogViewForm.questionnaireName"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="腾讯问卷用户ID">
                  <el-input
                    v-model="dialogViewForm.uid"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="昵称">
                  <el-input
                    v-model="dialogViewForm.nickname"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="市场">
                  <el-input
                    v-model="dialogViewForm.market"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="门店名称">
                  <el-input
                    v-model="dialogViewForm.storeName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="专卖证号">
                  <el-input
                    v-model="dialogViewForm.certificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="本香门店码绑定电话">
                  <el-input
                    v-model="dialogViewForm.bxPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="小程序用户门店名称">
                  <el-input
                    v-model="dialogViewForm.appStoreName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="小程序用户专卖证号">
                  <el-input
                    v-model="dialogViewForm.appCertificateNo"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="小程序用户手机号">
                  <el-input
                    v-model="dialogViewForm.appPhone"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="异常类型">
                  <el-input
                    v-model="dialogViewForm.exceptionTypeValue"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="异常处理结果"
                  required
                >
                  <el-radio-group
                    v-model="dialogDealForm.processResult"
                  >
                    <el-radio
                      v-if="dialogViewForm.exceptionType !== 4 && dialogViewForm.exceptionType !== 5"
                      :label="2"
                    >
                      忽略当前异常
                    </el-radio>
                    <el-radio :label="3">
                      当前数据无效
                    </el-radio>
                    <el-radio
                      v-if="dialogViewForm.exceptionType === 6"
                      :label="4"
                    >
                      更新腾讯问卷用户ID
                    </el-radio>
                    <el-radio
                      v-if="dialogViewForm.exceptionType === 7 || dialogViewForm.exceptionType === 8"
                      :label="5"
                    >
                      更新关联睿零售
                    </el-radio>
                    <el-radio
                      v-if="dialogViewForm.exceptionType === 7"
                      :label="6"
                    >
                      解除问卷用户关联睿零售
                    </el-radio>
                    <el-radio
                      v-if="dialogViewForm.exceptionType === 5"
                      :label="7"
                    >
                      问卷明细重新关联睿零售
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model="dialogDealForm.remark"
                    type="textarea"
                    maxlength="200"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog拖拽Mixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 调研问卷API
import { viewSurveyQuestionnaireDetailExceptionApi, updateProcessResultSurveyQuestionnaireDetailExceptionApi } from '@/api/v2/surveyQuestionnaireDetailException'

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      dialogViewForm: {},
      dialogDealForm: {},
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this;

        _this.dialogViewForm = {}
        _this.dialogDealForm = {
            processResult: 3,
            remark: ''
        }

        _this.loadSurveyQuestionnaireDetailExceptionData()

        _this.$nextTick(() => {
          _this.$refs.dialogViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadSurveyQuestionnaireDetailExceptionData () {
      let _this = this;
      viewSurveyQuestionnaireDetailExceptionApi({ id: _this.dataId }).then((response) => {
        const { data } = response;
        _this.dialogViewForm = data;
        _this.dialogDealForm.id = data.id
      })
    },
    // 保存
    handleSave () {
      let _this = this
        _this.$confirm(
            '是否确定保存当前处理异常信息？','系统提示',
            {
            confirmButtonText: '确定',
            cancelButtonText:'取消',
            type: 'warning',
            center: true
            }
        )
        .then(async () => {
        _this.loading = true
        updateProcessResultSurveyQuestionnaireDetailExceptionApi(this.dialogDealForm).then(res => {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
        }).catch(() => {
            this.loading = false
        })
        })
        .catch(() => { })
    },
    loadTableData () {
      this.$emit('reloadData')
      this.modalClose()
    },
    modalClose () {
      let _this = this;
      _this.$emit('update:dialogVisible', false)
    },
  }
}
</script>
<style lang="scss"  scoped>
</style>
